var _circle, _path, _path2, _path3, _path4, _path5, _circle2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 90,
    fill: "#EFF4FF",
    stroke: "#F9FBFF",
    strokeWidth: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.365 70.358V56.5644L131.252 70.358H118.365Z",
    fill: "#323946",
    stroke: "#323946"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.5 144.514H77.1058C71.7837 144.514 67.5 140.235 67.5 134.918V64.8929C67.5 59.5762 71.7837 55.2969 77.1058 55.2969H117.995L132.404 70.858L132.534 70.9876V108",
    stroke: "#323946",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.865 55.2969V70.858H132.404",
    stroke: "#323946",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5332 81.1023H109.817",
    stroke: "#323946",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5332 92.1248H97.8745",
    stroke: "#323946",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.749,
    cy: 118.749,
    r: 16.5,
    transform: "rotate(-45 109.749 118.749)",
    stroke: "#323946",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 120.356,
    y: 130.769,
    width: 2,
    height: 15,
    rx: 1,
    transform: "rotate(-45 120.356 130.769)",
    fill: "#323946",
    stroke: "#323946"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.8399986fb96ff42d59f44efe278455d1.svg";
export { ForwardRef as ReactComponent };